import { DEFAULT_SETTINGS, loadSettings } from '@/config/localSettings';
import { Config } from '@contiple/antd-ds';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';
import ja from './locales/ja';
import ko from './locales/ko';
import zh from './locales/zh';

const resources = {
  [Config.Language.ZH]: {
    translation: zh,
  },
  [Config.Language.EN]: {
    translation: en,
  },
  [Config.Language.KO]: {
    translation: ko,
  },
  [Config.Language.JA]: {
    translation: ja,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: loadSettings().language,
  fallbackLng: DEFAULT_SETTINGS.language,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
